const mountain = {
  50: '#E7E9EB',
  100: '#C4C9CD',
  200: '#9CA5AC',
  300: '#74808A',
  400: '#576571',
  500: '#394A58',
  600: '#334350',
  700: '#2C3A47',
  800: '#24323D',
  900: '#17222D',
  A100: '#70B8FF',
  A200: '#3D9EFF',
  A400: '#0A85FF',
  A700: '#0078F0'
};

export default mountain;
